import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'

import { AccountsPageType } from '../accounts/types'
import { AccountType } from './signup'

interface DisabledRegistrationModalState {
  isOpen: boolean
  page?: AccountsPageType | null
  accountType?: AccountType | null
}

const [disabledRegistrationModalState$, setDisabledRegistrationModalState] =
  createSignal<DisabledRegistrationModalState>()

export const [useDisabledRegistrationModalState] = bind(disabledRegistrationModalState$, {
  isOpen: false,
})

export const openDisabledRegistrationModal = ({
  page,
  accountType,
}: {
  page?: AccountsPageType | null
  accountType?: AccountType | null
}) => {
  setDisabledRegistrationModalState({ isOpen: true, page, accountType })
}

export const closeDisabledRegistrationModal = () => {
  setDisabledRegistrationModalState({ isOpen: false })
}
